import { useMemo, useState } from "react";
import { IPhoneReplyContext } from "../context";

export function usePhoneReplyState(): IPhoneReplyContext {
  const [replyText, setReplyText] = useState("");
  const [messageCallContacted, setMessageCallContacted] = useState("");
  const [messageCallType, setMessageCallType] = useState("");
  const [selectedToChannelValue, setSelectedToChannelValue] = useState("");

  return useMemo(
    () => ({
      replyText,
      messageCallContacted,
      messageCallType,
      selectedToChannelValue,
      setReplyText,
      setMessageCallContacted,
      setMessageCallType,
      setSelectedToChannelValue
    }),
    [replyText, messageCallContacted, messageCallType, selectedToChannelValue]
  );
}
